import { FirebaseOptions } from 'firebase/app'
import { ConfigurationOptions } from 'typesense/lib/Typesense/Configuration'

export interface PageData {
  company: { hashid?: string; name?: string; plan?: string }
  user: { email?: string; roles: string[] }
  firebase?: FirebaseOptions & { authEmulatorHost?: string }
  typesense?: ConfigurationOptions
  sentry?: { dsn: string }
  plausible?: { domain: string }
}

const EMPTY: PageData = { company: {}, user: { roles: [] } }

// Layout::Component::PageData renders this blob into the body of every page.
//
// Parsed on every read rather than memoised: Turbo replaces the body on a visit, so a cached parse would
// answer with the company you have just left, and a morph refresh keeps the same element while rewriting its
// contents, so even caching on element identity would go stale. The blob is under a kilobyte.
export function pageData(): PageData {
  const element = document.getElementById('js-page-data')
  if (element === null) return EMPTY

  return JSON.parse(element.textContent ?? '{}') as PageData
}

// Empty rather than asserting, because the found-company wizard runs with no company at all.
export function companyHashid(): string {
  return pageData().company.hashid ?? ''
}
